/**
 * Tutorial
 */
export const INCREMENT_TUTORIAL = 'INCREMENT_TUTORIAL'
export const SET_TUTORIAL = 'SET_TUTORIAL'
export const REGISTER_STEP = 'REGISTER_STEP'
export const UNREGISTER_STEP = 'UNREGISTER_STEP'
